import { environment as sharedEnvironment } from '@coverright/shared/config';

export const environment = {
  ...sharedEnvironment
};
